import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=0442d52c&scoped=true"
import script from "./AddChannel.vue?vue&type=script&lang=js"
export * from "./AddChannel.vue?vue&type=script&lang=js"
import style0 from "./AddChannel.vue?vue&type=style&index=0&id=0442d52c&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442d52c",
  null
  
)

export default component.exports